let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hhVwh")).then(() => parcelRequire('jLy0N'));